import React from "react";

export const SessionContext = React.createContext({
  sessionId: "",
  listLoaded: false,
  selectedElementRef: null,
  list: [],
  currentImageName: "",
  setCurrentImageName: () => console.error("Use a Provider to set this function"),
  currentEntry: "",
  setCurrentEntry: () => console.error("Use a Provider to set this function"),
  index: 0,
  setIndex: () => console.error("Use a Provider to set this function")
});
